import { useEffect } from "react";
import { Link } from "@/lib/router-compat";
import {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface BreadcrumbNavProps {
  items: { label: string; href?: string }[];
}

const BreadcrumbNav = ({ items }: BreadcrumbNavProps) => {
  // Inject BreadcrumbList JSON-LD for AI crawlers
  useEffect(() => {
    const existing = document.querySelector('script[data-breadcrumb-ld]');
    if (existing) existing.remove();

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Inicio",
          item: "https://tiemposhoy.com/",
        },
        ...items.map((item, i) => ({
          "@type": "ListItem",
          position: i + 2,
          name: item.label,
          ...(item.href ? { item: `https://tiemposhoy.com${item.href}` } : {}),
        })),
      ],
    };

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-breadcrumb-ld", "true");
    script.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script);

    return () => {
      const s = document.querySelector("script[data-breadcrumb-ld]");
      if (s) s.remove();
    };
  }, [items]);

  return (
    <Breadcrumb className="mb-6">
      <BreadcrumbList>
        <BreadcrumbItem>
          <BreadcrumbLink asChild>
            <Link to="/">Inicio</Link>
          </BreadcrumbLink>
        </BreadcrumbItem>
        {items.map((item, i) => (
          <span key={i} className="contents">
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              {item.href ? (
                <BreadcrumbLink asChild>
                  <Link to={item.href}>{item.label}</Link>
                </BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{item.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </span>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default BreadcrumbNav;
